import React, { useEffect, useState } from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import * as R from "ramda";
import { Link } from "react-router-dom";
import { ServicesEdit } from "../_common/serviceEdit";

import { ConnectionTypes, CommonServices, PersonalServices, AuxiliarOptions, OtherService, convertConnectionTypesToServiceType, isSocialNetwork, isInsurance } from "../../../../constants/utils/connectionTypes";

export const DashboardAnticipa = ({ userId, user, serviceDatas, connectionTypes, isLoading }) => {
	const [selectedUserConnection, setSelectedUserConnection] = useState(undefined);
	const [userDocuments, setUserDocuments] = useState({
		items: [doc("démarches", "communes", 0, 0), doc("démarches", "personnalisées", 0, 0)],
	});

	function doc(firstTitle, secondTitle, num, actions) {
		return { firstTitle: firstTitle, secondTitle: secondTitle, num: num, actions: actions };
	}
	const allServices = { ...CommonServices, ...PersonalServices, ...AuxiliarOptions, ...OtherService };
	useEffect(() => {
		let userCommunServices = Object.values(CommonServices)
			.filter((u) => connectionTypes.some((i) => i.connectionType === u.connectionType))
			.map((srv) => {
				let progress = serviceDatas.some((s) => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType)) ? 100 : 0;
				return progress === 100 ? 0 : 1;
			});

		let userPersonnalServices = Object.values(PersonalServices)
			.concat(Object.values(AuxiliarOptions))
			.concat(Object.values(OtherService))
			.filter((u) => connectionTypes.some((i) => (isSocialNetwork(i.connectionType) ? ConnectionTypes.socialNetworks === u.connectionType : isInsurance(i.connectionType) ? ConnectionTypes.insurance === u.connectionType : i.connectionType === u.connectionType)))
			.map((srv) => {
				let progress = serviceDatas.some((s) => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType)) ? 100 : 0;
				return progress === 100 ? 0 : 1;
			});

		let demarchesCommuneDocuments = userDocuments.items.find((d) => d.secondTitle === "communes");
		demarchesCommuneDocuments.num = userCommunServices.length;
		demarchesCommuneDocuments.actions = userCommunServices.reduce((a, b) => a + b, 0);

		let demarchesPersonnaliseeDocuments = userDocuments.items.find((d) => d.secondTitle === "personnalisées");
		demarchesPersonnaliseeDocuments.num = userPersonnalServices.length;
		demarchesPersonnaliseeDocuments.actions = userPersonnalServices.reduce((a, b) => a + b, 0);

		setUserDocuments({ ...userDocuments, items: userDocuments.items });
	}, [serviceDatas]);

	return (
		<article className="view-calc mb-auto">
			<h1 className="sr-only visually-hidden">Onboard</h1>
			<div className="container-fluid">
				<header className="rounded-bottom-left-sm rounded-top-right-sm mb-0 mb-4">
					<h2 className="sr-only visually-hidden">Status</h2>
					<div className="grid-sm grid-sm-narrow grid-lg-auto grid-hd-4">
						{userDocuments.items.map((d, index) => {
							return (
								<div key={index} className="card rounded shadow">
									<svg style={{ height: 0 }}>
										<defs>
											<linearGradient id="idCSS" gradientTransform="rotate(90)">
												<stop offset="0%" stopColor="#00b33c" />
												<stop offset="100%" stopColor="#66ccff" />
											</linearGradient>
										</defs>
									</svg>
									<div className="card-body media">
										<div className="media-progress mr-3">
											<CircularProgressbar value={(d.num - d.actions) / d.num} minValue={0} maxValue={1} background={true} text={d.num === 0 ? "0" : d.num.toString()} />
										</div>
										<div className="media-body my-auto text-truncate">
											<h3 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">
												{d.firstTitle}
												<br className="d-none d-md-block" /> {d.secondTitle}
											</h3>
											<p className="h3 text-dark font-weight-bolder lh-solid mb-0">{d.actions.toString()} actions à faire</p>
										</div>
									</div>
									{/* <div className="card-body media">

                                        <div className="rounded-max bg-common d-inherit mr-3 rounded-progress text-center">
                                            <p className="h2 o-40 font-weight-bolder m-auto">{d.num}</p>
                                        </div>
                                        <div className="media-body my-auto text-truncate">
                                            <h3 className="h5 o-40 text-uppercase font-weight-bolder mt-0 mb-2 text-truncate">{d.firstTitle}<br className="d-none d-md-block" /> {d.secondTitle}</h3>
                                            <p className="h3 text-dark font-weight-bolder lh-solid mb-0">{d.actions} actions</p>
                                        </div>
                                    </div> */}
								</div>
							);
						})}
					</div>
				</header>
			</div>
			<div className="auto-view py-3 pb-lg-0">
				<div className="container-fluid">
					<section className="block mt-4">
						<div className="grid-sm grid-1 grid-md-2 align-items-center mt-2">
							<div className="block my-auto">
								<h2 className="h6 lh-copy text-uppercase font-weight-bolder my-auto">VEUILLEZ COMPLETER 100% DES SERVICES SELECTIONNÉS POUR ACCEDER À L’ESPACE COURRIERS</h2>
								<p>Vous pouvez les supprimer pour les reprendre plus tard</p>
							</div>
							<div className="ml-md-auto">
								<Link to={`/facilita/${userId}/personal`} className="btn p-1 align-middle text-info">
									Sélectionner d'autres démarches <i className="eva eva-arrow-right-outline align-middle fs-lead"></i>
								</Link>
							</div>
						</div>
						<form className="grid-sm grid-sm-min grid-lg-demarche py-sm">
							{R.sortWith([R.ascend(R.prop("order"))])(Object.values(allServices).filter((u) => connectionTypes.some((i) => i.connectionType === u.connectionType))).map((srv, index) => {
								let progress = serviceDatas.some((s) => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType)) ? 100 : 0;
								return (
									<div
										key={index}
										className="form-group col col-lg-3 col-xl-2"
										data-toggle="modal"
										data-target="#servicesEdit"
										onClick={(e) => {
											setSelectedUserConnection(srv);
										}}>
										<div className={"card card-body text-center picker-card"}>
											<img className="img-fluid mx-auto mt-auto mb-2 h-6 py-1" src={srv.icon} alt={srv.title} />
											<h3 className={"h6 text-uppercase font-weight-bolder container-slim" + (progress === 100 ? "" : " mx-auto mt-auto")}>{srv.title}</h3>
											<p className={"h5 mt-auto lh-copy" + (progress === 100 ? " o-0" : "")}>À compléter</p>
											<div className={"progress position-relative w-100 text-center h-4 rounded-max align-items-center mt-auto mb-0" + (progress === 100 ? " bg-white" : " bg-common 0")}>
												<div className={"progress-bar h-100 rounded-inherit" + (progress === 100 ? " bg-success o-20" : " gradient-prime o-50")} style={{ width: `${progress}%` }} role="progressbar"></div>
												<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (progress === 100 ? " text-success" : " o-80")} role="progressbar">
													{progress}%
												</div>
											</div>
										</div>
									</div>
								);
							})}
							{/* {R.sortWith([R.ascend(R.prop("title"))])(Object.values(CommonServices).filter((u) => connectionTypes.some((i) => i.connectionType === u.connectionType))).map((srv, index) => {
									let progress = serviceDatas.some((s) => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType)) ? 100 : 0;
									return (
										<div
											key={index}
											className="form-group col col-lg-3 col-xl-2"
											data-toggle="modal"
											data-target="#servicesEdit"
											onClick={(e) => {
												setSelectedUserConnection(srv);
											}}>
											<div className={"card card-body text-center picker-card"}>
												<img className="img-fluid mx-auto mt-auto mb-2 h-6 py-1" src={srv.icon} alt={srv.title} />
												<h3 className={"h6 text-uppercase font-weight-bolder container-slim" + (progress === 100 ? "" : " mx-auto mt-auto")}>{srv.title}</h3>
												<p className={"h5 mt-auto lh-copy" + (progress === 100 ? " o-0" : "")}>À compléter</p>
												<div className={"progress position-relative w-100 text-center h-4 rounded-max align-items-center mt-auto mb-0" + (progress === 100 ? " bg-white" : " bg-common 0")}>
													<div className={"progress-bar h-100 rounded-inherit" + (progress === 100 ? " bg-success o-20" : " gradient-prime o-50")} style={{ width: `${progress}%` }} role="progressbar"></div>
													<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (progress === 100 ? " text-success" : " o-80")} role="progressbar">
														{progress}%
													</div>
												</div>
											</div>
										</div>
									);
								})}
								{R.sortWith([R.ascend(R.prop("title"))])(
									Object.values(PersonalServices)
										.concat(Object.values(AuxiliarOptions))
										.filter((u) => connectionTypes.some((i) => (isSocialNetwork(i.connectionType) ? ConnectionTypes.socialNetworks === u.connectionType : isInsurance(i.connectionType) ? ConnectionTypes.insurance === u.connectionType : i.connectionType === u.connectionType)))
								).map((srv, index) => {
									let progress = serviceDatas.some((s) => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType)) ? 100 : 0;
									return (
										<div
											key={index}
											className="form-group col col-lg-3 col-xl-2"
											data-toggle="modal"
											data-target="#servicesEdit"
											onClick={(e) => {
												setSelectedUserConnection(srv);
											}}>
											<div className={"card card-body text-center picker-card"}>
												<img className="img-fluid mx-auto mt-auto mb-2 h-6 py-1" src={srv.icon} alt={srv.title} />
												<h3 className={"h6 text-uppercase font-weight-bolder container-slim" + (progress === 100 ? "" : " mx-auto mt-auto")}>{srv.title}</h3>
												<p className={"h5 mt-auto lh-copy" + (progress === 100 ? " o-0" : "")}>À compléter</p>
												<div className={"progress position-relative w-100 text-center h-4 rounded-max align-items-center mt-auto mb-0" + (progress === 100 ? " bg-white" : " bg-common 0")}>
													<div className={"progress-bar h-100 rounded-inherit" + (progress === 100 ? " bg-success o-20" : " gradient-prime o-50")} style={{ width: `${progress}%` }} role="progressbar"></div>
													<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (progress === 100 ? " text-success" : " o-80")} role="progressbar">
														{progress}%
													</div>
												</div>
											</div>
										</div>
									);
								})}
								{R.sortWith([R.ascend(R.prop("title"))])(Object.values(OtherService).filter((u) => connectionTypes.some((i) => i.connectionType === u.connectionType))).map((srv, index) => {
									let progress = serviceDatas.some((s) => s.serviceType === convertConnectionTypesToServiceType(srv.connectionType)) ? 100 : 0;
									return (
										<div
											key={index}
											className="form-group col col-lg-3 col-xl-2"
											data-toggle="modal"
											data-target="#servicesEdit"
											onClick={(e) => {
												setSelectedUserConnection(srv);
											}}>
											<div className={"card card-body text-center picker-card"}>
												<img className="img-fluid mx-auto mt-auto mb-2 h-6 py-1" src={srv.icon} alt={srv.title} />
												<h3 className={"h6 text-uppercase font-weight-bolder container-slim" + (progress === 100 ? "" : " mx-auto mt-auto")}>{srv.title}</h3>
												<p className={"h5 mt-auto lh-copy" + (progress === 100 ? " o-0" : "")}>À compléter</p>
												<div className={"progress position-relative w-100 text-center h-4 rounded-max align-items-center mt-auto mb-0" + (progress === 100 ? " bg-white" : " bg-common 0")}>
													<div className={"progress-bar h-100 rounded-inherit" + (progress === 100 ? " bg-success o-20" : " gradient-prime o-50")} style={{ width: `${progress}%` }} role="progressbar"></div>
													<div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (progress === 100 ? " text-success" : " o-80")} role="progressbar">
														{progress}%
													</div>
												</div>
											</div>
										</div>
									);
								})} */}
						</form>
					</section>
				</div>
			</div>
			<ServicesEdit selectedUserConnection={selectedUserConnection} activeUserConnections={connectionTypes} serviceDatas={serviceDatas} isLoading={isLoading} userId={userId} user={user} displayComments={false} disableModifications={false} generateLetters={false} />
		</article>
	);
};
